import React, { useEffect, useState } from "react";
import { MapPin } from "lucide-react";
import api from "@/lib/api";
import { PageHero } from "@/components/Shared";
import EventCard from "@/components/EventCard";
import { useSiteContent } from "@/lib/siteContent";

export const EVENTS_PAGE_DEFAULTS = {
  title: "Upcoming Events",
  subtitle: "Reserve your seat at Victoria's most competitive poker tournaments. Click any event for the full run-down — times, structure, costs and food.",
};

export default function Events() {
  const [events, setEvents] = useState([]);
  const content = useSiteContent();
  useEffect(() => {
    api.get("/events?status=upcoming").then((r) => setEvents(r.data)).catch(() => {});
  }, []);

  const mapUrl = () => {
    const stops = [...new Set(events.map((e) => `${e.venue_name || ""} ${e.address || ""}`.trim()).filter(Boolean))];
    if (stops.length === 0) return null;
    if (stops.length === 1) return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(stops[0])}`;
    return `https://www.google.com/maps/dir/${stops.map((s) => encodeURIComponent(s)).join("/")}`;
  };
  const url = mapUrl();
  if (!content) return <div className="min-h-[60vh]" />;
  const page = { ...EVENTS_PAGE_DEFAULTS, ...(content.events || {}) };

  return (
    <div data-testid="events-page">
      <PageHero
        title={page.title}
        subtitle={page.subtitle}
        image="https://images.unsplash.com/photo-1596451190630-186aff535bf2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600"
        testId="events-hero"
      />
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24">
        {url && (
          <div className="mb-8 flex justify-end">
            <a href={url} target="_blank" rel="noreferrer" data-testid="events-map-btn"
              className="inline-flex items-center gap-2 px-5 py-3 text-xs uppercase tracking-widest border border-gold/40 text-gold hover:bg-gold hover:text-navy transition-colors">
              <MapPin className="w-4 h-4" /> View Venues on Map
            </a>
          </div>
        )}
        {events.length === 0 ? (
          <p className="text-slate-400 text-center py-20">No upcoming events right now. Check back soon.</p>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {events.map((e, i) => <EventCard key={e.id} event={e} index={i} />)}
          </div>
        )}
      </div>
    </div>
  );
}
